module.exports = "/fonts/opensansextrabold.woff";